import React from 'react';
import FaqPortal from "@Features/faq/components/FaqPortal";
import PortalMap from "@Portals/components/PortalMap";
import Portal from "@Portals/components/Portal";
import BestPriceOnDateRouteList from "@Pages/stationToStation/components/BestPriceOnDateRouteList";
import ErrorBoundary from "@Errors/components/ErrorBoundary"
import NextDepartures from "./NextDepartures";
import Review from "./LeaveReviewButton";
import BestPriceRouteType from "@Pages/stationToStation/types/BestPriceRoute.type";
import ReviewsPortal from "@Pages/reviewWidget/components/ReviewsPortal";
import GenericPopover from "@Popover/components/GenericPopover";
import {useTranslation} from "@Translation/hooks/useTranslation";
import StopInfo from "@Pages/stationPage/components/StopInfo";
import IconInfo from "@Icons/IconInfo";
import GbtVehiclesPortal from "@Features/getByTransfer/components/GbtVehiclesPortal";
import permalinkTypeId from "@/constants/PermalinkTypeId";
import TableOfContentsPortal from "@Features/tableOfContents/components/TableOfContentsPortal";
import toggleStaticMainContentElements from "@Features/domElements/functions/toggleStaticMainContentElements";
import {Colors} from "@Styles/Colors.style";

const StationPage = () => {
    toggleStaticMainContentElements(true)
    const isPortPage = window.permalinkTypeId === permalinkTypeId.port
    const overlayContent: string = isPortPage ? useTranslation("p_page.info_button") : useTranslation("s_page.info_button")

    return (
        <ErrorBoundary shouldReload={false}>
            {window.nextDeparturesData && (
                <PortalMap className="gb--next-departures">
                    <NextDepartures
                        nextDepartures={window.nextDeparturesData}
                        stationName={window.departingStationName}
                    />
                </PortalMap>
            )}
            <Portal id="review-info">
                <GenericPopover
                    trigger={<IconInfo fill={Colors.neutralBlackColor}/>}
                    overlay={overlayContent}
                    id="review-info-button"
                />
            </Portal>

            <PortalMap className="react--portal--write-review-box">
                <Review/>
            </PortalMap>
            <ErrorBoundary shouldReload={false}>
                <PortalMap className="stops-info-portal">
                    <StopInfo/>
                </PortalMap>
            </ErrorBoundary>
            {window.bestPriceOnDateData && window.bestPriceOnDateData[3] && (
                <Portal
                    id="popularTrainRoutes"
                    type="div"
                >
                    <BestPriceOnDateRouteList
                        bestPriceOnDateData={(window.bestPriceOnDateData as Record<number, BestPriceRouteType[]>)[3]}
                    />
                </Portal>
            )}
            <ErrorBoundary shouldReload={false}>
                <ReviewsPortal/>
            </ErrorBoundary>
            <FaqPortal/>
            <GbtVehiclesPortal/>
            {window.tableOfContents && (<TableOfContentsPortal/>)}
        </ErrorBoundary>
    )
}

export default StationPage;